// Tracks browser back/forward independently of React Router. A native `popstate`
// fires just before the Router remounts the target page, so on mount a component
// can tell "the user hit back/forward" (restore cached state + scroll) apart from
// "fresh navigation here" (start clean at the top).
//
// This is more reliable than useNavigationType, whose value can flip to PUSH when
// a page normalizes its own URL via setSearchParams — which would cancel restores.
let lastPopAt = 0;

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => { lastPopAt = Date.now(); });
}

/**
 * True if a back/forward navigation happened within the last `ms` milliseconds —
 * i.e. this mount is the result of the user going back/forward, not a fresh push.
 */
export function cameFromBack(ms = 3000) {
  return Date.now() - lastPopAt < ms;
}

// Track the previous in-app pathname so a component can decide whether going
// "back" would actually return to a known place (e.g. the featured wall) — and
// use real history navigation (which restores scroll) instead of a fresh push.
let prevPath = null;
let curPath = null;

/** Record a pathname change. Call on every location change (see App.js). */
export function recordPath(pathname) {
  if (pathname === curPath) return;
  prevPath = curPath;
  curPath = pathname;
}

/** The pathname we were on immediately before the current one (or null). */
export function getPreviousPath() {
  return prevPath;
}
